import React, { useState, useEffect, useMemo } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsUpdateMasive } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

function UpdateListModal(props) {
  const { prices, priceListId, showNotify } = props;

  const [priceLists, setPriceLists] = useState([]);
  const [selectedList, setSelectedList] = useState();

  async function listPriceLists() {
    let res = await wsGetAll('logi/price-list');
    if (res.success) setPriceLists(res.data);
  }

  async function update() {
    let data = {
      from_list_id: priceListId,
      to_list_id: selectedList.id,
    };
    data.prices = prices.map((price) => price.id);

    let res = await wsUpdateMasive('logi/price-list/update-list-from', data);
    if (res.success) {
      showNotify(res.message);
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    listPriceLists();
  }, []);

  useEffect(() => {
    if (props.model.open === false) setSelectedList(undefined);
  }, [props.model.open]);

  const validPriceLists = useMemo(() => {
    return priceLists.filter((list) => list.id !== parseInt(priceListId));
  }, [priceLists, priceListId]);

  return (
    <Modal
      title={`Actualizar precios de otra lista`}
      model={props.model}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      entity=""
      onSubmit={update}
    >
      <Autocomplete
        options={validPriceLists}
        getOptionLabel={(item) => item.ListName}
        renderInput={(params) => (
          <TextField {...params} label="Lista de precios destino" margin="normal" required />
        )}
        value={selectedList || null}
        onChange={(_, list) => {
          if (list === null) return setSelectedList(undefined);

          setSelectedList(list);
        }}
      />
      <h4>
        Se actualizarán/crearan {prices.length} precios en la lista seleccionada, esta acción es
        irreversible, desea continuar?
      </h4>
    </Modal>
  );
}

export default UpdateListModal;
